// extracted by mini-css-extract-plugin
export default {"table":"DepartmentListingTable-module__table__raUzq","link":"DepartmentListingTable-module__link__T63qu"};